
export const GLOBAL_PATHS = {
  FONTS: "/assets/fonts/",
  ICONS: "/assets/icons/",
  IMAGES: "/assets/images/",
  GLASS: "/assets/images/glass/",
  GLASS2: "/assets/images/glass2/",
  STYLE_BANNERS: "/assets/images/style/",
  COVERS: "/assets/covers/",
  COVERS_LIQUID: "/assets/covers/liquid/",
  PUBLIC: "/",
  SARKI: "/sarki/",
  PARTNERS: "/assets/partners/",
  BRAND: "/assets/brand/",
  ILLUSTRATIONS: "/assets/illustrations/",
}